export const STATUS_MAP = {
  REFUND_SUCCESSFUL: 'Refunded',
  INSERT_SUCCESSFUL: 'Inserted',
  KOUNT_DENIAL: 'Fraud denial',
  PAYMENT_ERROR: 'Payment error',
  REFUND_ERROR: 'Refund error',
};

const REFUND_SUCCESSFUL = 'REFUND_SUCCESSFUL';
const INSERT_SUCCESSFUL = 'INSERT_SUCCESSFUL';
const KOUNT_DENIAL = 'KOUNT_DENIAL';
const PAYMENT_ERROR = 'PAYMENT_ERROR';
const UPDATE_SUCCESSFUL = 'UPDATE_SUCCESSFUL';
const REFUND_ERROR = 'REFUND_ERROR';

export const RBI_ORDER_STATUSES = {
  REFUND_SUCCESSFUL,
  INSERT_SUCCESSFUL,
  KOUNT_DENIAL,
  PAYMENT_ERROR,
  UPDATE_SUCCESSFUL,
  REFUND_ERROR,
};

export const SUPPORT_KEYWORD = 'SUPPORT';

export const STORE_LOCATOR_URLS_BY_BRAND = {
  'Burger King': 'https://www.bk.com/store-locator',
  Popeyes: 'https://www.popeyes.com/store-locator',
  'Tim Hortons': 'https://www.timhortons.ca/store-locator',
  'Burger King UK': 'https://www.burgerking.co.uk/store-locator',
  'Burger King CA': 'https://www.burgerking.ca/store-locator',
  'Tim Hortons US': 'https://www.timhortons.com/store-locator',
};
